import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import LoadingSpinner from "../LoadingSpinner";
import Grid from "../Grid";
import {
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import { typeValidation } from "../validations/vehicleCreation";
import { vehicleTypeById } from "../../api/vehicleapi";
import ButtonRenderer from "../renderer/ButtonRenderer";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import SearchDropdown from "../input/SearchDropdown";
import Button from "../input/Button";
import { duplicateVehicleTypeValidator } from "../../validators";
import { AUTH_TYPES, FORMS, MODULES } from "../../const";
import { isNumber } from "../../helper";
import { toast } from "react-toastify";
import DeleteButtonRenderer from "../renderer/DeleteButtonRenderer";

const FORM = FORMS.VEHICLE.TYPE.form;

const VehicleTypes = forwardRef(
  ({ dropdown, isLoading, editMode, currentValues }, ref) => {
    const [vetCount, setVetCount] = useState(2);
    const [vetTypes, setVetTypes] = useState([]);
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    const [isAddLoading, setIsAddLoading] = useState(false);
    const [currentType, setCurrentType] = useState({});
    const [buttonClicked, setButtonClicked] = useState(false);
    const [deletedList, setDeletedList] = useState([]);

    const [currentErrors, setCurrentErrors] = useState({});

    const [types, setTypes] = useState({
      vetCode: "", //doesn't exist in front end
      vetPrimary: "",
      vetType: "",
      vetTypeValue: "",
      vetDescription: "",
      vetCbm: "",
      vetCbmUom: "", //doesn't exist in front end
      vetMaxWeight: "",
      vetMinWeight: "", //doesn't exist in front end
      vetLoadingTime: "",
      vetUnloadingTime: "", //doesn't exist in front end
      vetUom: "",
      vetEmptyTruckWeight: "", //doesn't exist in front end   AND ADD a column in the table
      vetStatus: 2, //doesn't exist in front end
      vetActive: 1,
    });

    const booleanOptions = [
      { key: "1", value: true, text: "Yes" },
      { key: "0", value: false, text: "No" },
    ];

    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentTypes = [];
          let id = 2;
          for (let currentValue of currentValues) {
            currentTypes.push({
              ...currentValue,
              vetVehicle: currentValue.vetVehicleId,
              vetType: currentValue.vetTypeId,
              id: id,
            });
            id++;
          }
          setVetCount(id);
          setVetTypes(currentTypes);
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      if (buttonClicked) {
        setTypes({
          vetCode: "", //doesn't exist in front end
          vetPrimary: "",
          vetType: "",
          vetTypeValue: "",
          vetDescription: "",
          vetCbm: "",
          vetCbmUom: "", //doesn't exist in front end
          vetMaxWeight: "",
          vetMinWeight: "", //doesn't exist in front end
          vetLoadingTime: "",
          vetUnloadingTime: "", //doesn't exist in front end
          vetUom: "",
          vetEmptyTruckWeight: "", //doesn't exist in front end   AND ADD a column in the table
          vetStatus: 2, //doesn't exist in front end
          vetActive: 1,
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
        setButtonClicked(false);
        setCurrentType({});
      }
    }, [buttonClicked]);

    useEffect(() => {
      if (Object.keys(currentType).length > 0) {
        setTypes({
          ...currentType,
          // vetTypeValue: "",
        });
      }
    }, [editMode, currentType]);

    useImperativeHandle(ref, () => ({
      resetGrid: () => {
        setVetTypes([]);
      },
      // getData: () => (vetTypes.length > 0 ? vetTypes[0] : types),
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            unmodified: [],
            created: [],
            deleted: deletedList,
          };

          vetTypes.forEach((type) => {
            if (type.vetId && type.vetId !== null) {
              if (type.modified) {
                updateState.modified.push(type);
              } else {
                updateState.unmodified.push(type);
              }
            } else {
              updateState.created.push(type);
            }
          });
          return updateState;
        } else {
          return vetTypes;
        }
      },
      validateForm: () => {
        return vetTypes.length <= 0;
      },
      validatePrimary : ()=>{
        let isPrimaryAvailable = false;
        for(let type of vetTypes){
          if(type.vetPrimary === 1 || type.vetPrimary === true ){
            isPrimaryAvailable = true;
          }
        }
        // if(!isPrimaryAvailable){
        //  setCurrentErrors({...currentErrors,vetPrimary : "At least one vehicle type must be marked as Primary (Yes)."})
        // }
        return isPrimaryAvailable;
      }
    }));

    const onAddClick = async () => {
      setIsAddLoading(true);

      if (
        types.vetPrimary === true &&
        vetTypes.some((v) => v.vetPrimary === true && v.id !== types.id)
      ) {
        toast.warn("Only one vehicle type can be marked as primary.", {
          containerId: "Main",
          autoClose: 2000,
        });
        setIsAddLoading(false);
        return;
      }
      if (
        !types.vetId ||
        (types.vetId && types.vetType !== currentType.vetType)
      ) {
        if (duplicateVehicleTypeValidator(vetTypes, types.vetType, types.id)) {
          setCurrentErrors({
            ...currentErrors,
            vetType: "This vehicle type has already been added.",
          });
          setIsAddLoading(false);
          return;
        }
      }

      const typesErrors = typeValidation(types);
      if (Object.keys(typesErrors).length === 0) {
        const vetTypeObj = await vehicleTypeById(types.vetType);
        const vetTypeValue = vetTypeObj !== null ? vetTypeObj.vhtType : "";
        const vetUomValue = await getTextByValueAndKey("uom", types.vetUom);
        if (!types.vetId || types.vetId === null) {
          if (!types.id || types.id === null) {
            setVetTypes((prevState) => [
              ...prevState,
              {
                ...types,
                vetTypeValue,
                vetUomValue,
                id: vetCount,
              },
            ]);
            setVetCount((prevState) => ++prevState);
          } else {
            setVetTypes((prevState) =>
              prevState.filter((type) => type.id !== types.id)
            );

            setVetTypes((prevState) => [
              ...prevState,
              {
                ...types,
                vetTypeValue,
                vetUomValue,
              },
            ]);
          }
        } else {
          setVetTypes((prevState) =>
            prevState.filter((type) => type.vetId !== types.vetId)
          );

          setVetTypes((prevState) => [
            ...prevState,
            {
              ...types,
              vetTypeValue,
              vetUomValue,
              modified: true,
            },
          ]);
        }

        setButtonClicked(true);
      }
      setCurrentErrors(typesErrors);
      document.querySelector("#vehicle-details-form").classList.add("error");
      setIsAddLoading(false);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Types</h4>
              <div className="two fields">
                <Dropdown
                  label="Primary (Yes/No)"
                  // required={true}
                  error={currentErrors.vetPrimary}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vet_primary"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vetPrimary: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={booleanOptions}
                  style={{ height: "20px" }}
                  placeholder="Primary (Yes/No)"
                  value={types.vetPrimary}
                  onChange={(e, data) =>
                    setTypes((prevState) => ({
                      ...prevState,
                      vetPrimary: data.value,
                    }))
                  }
                />

                <SearchDropdown
                  key={1}
                  multiGrid={true}
                  multiGridCurrentValue={types.vetTypeValue}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vet_type"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setTypes((prevState) => ({
                      ...prevState,
                      vetType: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setTypes((prevState) => ({
                      ...prevState,
                      vetType: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "vehicle_type",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_vehicle_type",
                    primaryKey: "vht_id",
                    fieldName: "vht_type",
                    id: types.vetType,
                  }}
                  required={true}
                  label="Type"
                  error={currentErrors.vetType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vetType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.vetDescription}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vet_description"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vetDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="description"
                  placeholder="Description"
                  value={types.vetDescription}
                  onChange={(e) =>
                    setTypes((prevState) => ({
                      ...prevState,
                      vetDescription: e.target.value,
                    }))
                  }
                />

                <Input
                  label="Vehicle Loading Time"
                  error={currentErrors.vetLoadingTime}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vet_loading_time"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vetLoadingTime: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  step={0.0001}
                  min={0}
                  name="Vehicle Loading Time"
                  placeholder="Vehicle Loading Time"
                  value={types.vetLoadingTime}
                  onChange={(e) =>
                    setTypes((prevState) => ({
                      ...prevState,
                      vetLoadingTime: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="ui segment">
                <div className="three fields">
                  <Input
                    label="Max Weight"
                    error={currentErrors.vetMaxWeight}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="vet_max_weight"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vetMaxWeight: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="number"
                    step={0.1}
                    name="maxWeight"
                    placeholder="Max Weight"
                    value={types.vetMaxWeight}
                    onChange={(e) => {
                      const value = e.target.value;
                      const Regex = /^\d*\.?\d?$/;
                      if (Regex.test(value) || value === "") {
                        setTypes((prevState) => ({
                          ...prevState,
                          vetMaxWeight: e.target.value,
                        }));
                      } else {
                        return;
                      }
                    }}
                    min={0}
                  />
                  <Input
                    label="Empty Truck Weight"
                    error={currentErrors.vetEmptyTruckWeight}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="vet_empty_truck"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vetEmptyTruckWeight: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="number"
                    step={0.1}
                    name="emptyTruckWeight"
                    placeholder="Empty Truck Weight"
                    value={types.vetEmptyTruckWeight}
                    onChange={(e) => {
                      const value = e.target.value;
                      const Regex = /^\d*\.?\d?$/;
                      if (Regex.test(value) || value === "") {
                        setTypes((prevState) => ({
                          ...prevState,
                          vetEmptyTruckWeight: e.target.value,
                        }));
                      } else {
                        return;
                      }
                    }}
                    min={0}
                  />
                  <Dropdown
                    label="UOM"
                    error={currentErrors.vetUom}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="vet_uom"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vetUom: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    options={dropdown.vetUOMOpt}
                    style={{ height: "20px" }}
                    placeholder="UOM"
                    value={types.vetUom}
                    onChange={(e, data) =>
                      setTypes((prevState) => ({
                        ...prevState,
                        vetUom: data.value,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="two fields">
                <Input
                  label="CBM"
                  error={currentErrors.vetCbm}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vet_cbm"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vetCbm: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  placeholder="CBM"
                  name="cbm"
                  value={types.vetCbm}
                  onChange={(e) =>
                    setTypes((prevState) => ({
                      ...prevState,
                      vetCbm: parseFloat(e.target.value),
                    }))
                  }
                />
                {/* <Dropdown
                  label="Active"
                  error={currentErrors.vetActive}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vet_active"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vetActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.activeOpt}
                  style={{ height: "20px" }}
                  placeholder="Active"
                  value={types.vetActive}
                  onChange={(e, data) =>
                    setTypes((prevState) => ({
                      ...prevState,
                      vetActive: data.value,
                    }))
                  }
                /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  authenticated={true}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={`${FORM}`}
                  create={Object.keys(currentType).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                heading="Vehicle Type List"
                config={[
                  { headerName: "Vehicle Primary", field: "vetPrimary" },
                  { headerName: "Vehicle Type", field: "vetTypeValue" },
                  {
                    headerName: "Vehicle Description",
                    field: "vetDescription",
                  },
                  {
                    headerName: "Vehicle Loading Time",
                    field: "vetLoadingTime",
                  },
                  { headerName: "CMB", field: "vetCbm" },
                  { headerName: "UOM", field: "vetUomValue" },
                  { headerName: "Max Weight", field: "vetMaxWeight" },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.CREATE,
                      clickHandler: () => {
                        setCurrentType(params.data);
                      },
                      label: "Edit",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Master,
                      editMode: editMode,
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.DELETE,
                      clickHandler: () => {
                        if (params.data.vetId && params.data.vetId !== null) {
                          setDeletedList((prevState) => [
                            ...prevState,
                            params.data.vetId,
                          ]);
                        }
                        setVetTypes((prevTypes) =>
                          prevTypes.filter(
                            (types) => types.id !== params.data.id
                          )
                        );
                      },
                      message:
                          "Are you sure you want to delete this Vehicle Type?",
                      label: "Delete",
                      className: "ui red button",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Master,
                      editMode:
                        params.data.vetId !== null &&
                        isNumber(params.data.vetId),
                    }),
                  },
                ]}
                content={vetTypes}
              />
            </div>
          </form>
        )}
      </>
    );
  }
);

export default VehicleTypes;
